import React from 'react';

const TABS = [
  { id: 'modules', label: 'Modules' },
  { id: 'flow', label: 'Flow' },
  { id: 'details', label: 'Details' },
];

export default function MobileStepTabs({ mobileTab, setMobileTab, flowCount }) {
  return (
    <div className="lg:hidden flex px-4 pt-3 pb-2 gap-2 border-b border-[#EEE9FB] overflow-x-auto zara-scroll">
      {TABS.map((t) => (
        <button
          key={t.id}
          onClick={() => setMobileTab(t.id)}
          className={`shrink-0 px-3.5 py-1.5 rounded-full text-[12.5px] font-semibold transition-colors ${
            mobileTab === t.id ? 'bg-[#5B4FE8] text-white' : 'bg-[#F1ECFE] text-[#4A4463]'
          }`}
        >
          {t.id === 'flow' ? `${t.label} (${flowCount})` : t.label}
        </button>
      ))}
    </div>
  );
}
